import React, { useEffect, useState } from "react"
import { Table, Row, Col, Input, Modal, Form, Label } from "reactstrap"
import { useNavigate } from "react-router-dom"
import { useMemo } from "react"
import { useTable, usePagination, useGlobalFilter } from "react-table"

import {
  fetchNodeData,
  FetchNodeDeleteData,
  FetchNodePostData,
  FetchNodePutData,
} from "utils/common-fetchData"
import secureLocalStorage from "react-secure-storage"
import Loader from "pages/Separate/Loader"
import Swal from "sweetalert2"
import NewPagination from "components/Common/Newpagination"
import axios from "axios"
import configure from "configure"
import AccessDeniedPopup from "routes/AccessDeniedPopup"
import * as XLSX from "xlsx"
import { saveAs } from "file-saver"

function CategoryModal({
  status,
  setStatus,
  categoryName,
  setCategoryName,
  categoryId,
  handleAddCategory,
  handleEditCategory,
}) {
  return (
    <Modal isOpen={status} size="sm" className="bd-custom-md-2" centered>
      <div className="modal-header">
        <h5 className="modal-title mt-0">
          {categoryId ? "Edit" : "Add"} Category
        </h5>
        <button
          type="button"
          onClick={() => setStatus(false)}
          className="btn-modal-close"
        >
          <span aria-hidden="true" className="btn-modal-span">
            &times;
          </span>
        </button>
      </div>
      <div className="modal-body">
        <Form className="row" onSubmit={categoryId ? handleEditCategory : handleAddCategory}> 
          <div className="mb-3 col-md-12">
            <Label>
              Category Name<span className="text-danger"> *</span>
            </Label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Category Name"
              value={categoryName}
              onChange={e => {
                console.log("e.target.value: ", e.target.value)
                setCategoryName(e.target.value)
              }}
              required
            />
          </div>
          <div className="mt-3">
            <button type="submit" className="border-radius btn btn-purple">
              <i className="fas fa-save me-2"></i>
              Submit
            </button>
          </div>
        </Form>
      </div>
    </Modal>
  )
}

function TableContainer({
  columns,
  data,
  categoryName,
  setCategoryName,
  handleAddCategory,
  setStatus,
  status,
  canAdd,
  onAddPermission,
}) {
  const [fixedContent, setFixedContent] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 160) {
        setFixedContent(true)
      } else {
        setFixedContent(false)
      }
    }

    document.addEventListener("scroll", handleScroll)

    return () => {
      document.removeEventListener("scroll", handleScroll)
    }
  }, [])
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    usePagination
  )

  const { pageIndex, pageSize, globalFilter } = state
  const navigate = useNavigate()

  return (
    <div className="px-2">
      {/* Fixed Buttons */}
      <div
        className={`flex-column fixed-buttons ${
          fixedContent ? "d-flex" : "d-none"
        }`}
      >
        {canAdd && (
          <button
            onClick={onAddPermission}
            className="btn btn-purple border-radius fix-btn"
          >
            <i className="fas fa-plus me-2"></i>
            <span>Service</span>
          </button>
        )}
        <a
          onClick={() => navigate(-1)}
          className="btn btn-red border-radius fix-btn"
        >
          <i className="dripicons-cross me-2 icon-center"></i>
          <span>Cancel</span>
        </a>
      </div>

      {/* Table + Filters */}
      <Row className="mb-2">
        <Col lg={2}>
          <select
            className="border-radius form-select"
            style={{ width: "100px" }}
            value={pageSize}
            onChange={e => setPageSize(Number(e.target.value))}
          >
            {[10, 20, 30, 40, 50].map(pageSize => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
        </Col>
        <Col className="d-flex justify-content-end">
          <div className="me-4">
            <div className="search-box me-xxl-2 my-xxl-0 d-inline-block">
              <div className="position-relative">
                <input
                  onChange={e => setGlobalFilter(e.target.value)}
                  type="text"
                  className="border-radius form-control rounded h-100"
                  placeholder="Search..."
                  value={globalFilter || ""}
                />
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </div>
          </div>
          <div>
            {canAdd && (
              <button
                className="border-radius btn btn-purple"
                onClick={onAddPermission}
              >
                <i className="fas fa-plus me-2 icon-size"></i>Category
              </button>
            )}
            <button
              className="border-radius btn text-white ms-md-2 btn-red"
              onClick={() => navigate(-1)}
            >
              <i className="dripicons-cross me-2 icon-center"></i>Cancel
            </button>
          </div>
        </Col>
      </Row>

      {/* Table */}
      <Table className="table table-bordered mt-4" {...getTableProps()}>
        <thead className={`${fixedContent ? "fixed-setting-header" : ""}`}>
          {headerGroups.map((headerGroup, i) => (
            <tr key={i} {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column, index) => (
                <th
                  key={index}
                  className={`${column.className}`}
                  // className={`col-md-${index === 1 ? "4" : "2"}`}
                  {...column.getHeaderProps()}
                >
                  {column.render("Header")}
                </th>
              ))}
            </tr>
          ))}
        </thead>

        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row)
            return (
              <tr className="row-hover" {...row.getRowProps()} key={i}>
                {row.cells.map((cell, index) => (
                  <td
                    // className={`col-md-${index === 1 ? "4" : "2"}`}
                    className={` ${cell.column.className}`}
                    key={index}
                    {...cell.getCellProps()}
                  >
                    {cell.render("Cell")}
                  </td>
                ))}
              </tr>
            )
          })}
        </tbody>
      </Table>

      {/* Pagination */}
      <Row className="justify-content-md-end justify-content-center align-items-center">
        <NewPagination
          gotoPage={gotoPage}
          canPreviousPage={canPreviousPage}
          previousPage={previousPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
          pageSize={pageSize}
          page={page}
          data={data}
          nextPage={nextPage}
        />
      </Row>

      {/* Modal */}

      <CategoryModal
        status={status}
        setStatus={setStatus}
        setCategoryName={setCategoryName}
        categoryName={categoryName}
        handleAddCategory={handleAddCategory}
      />
    </div>
  )
}

const ASSESSMENT_MODULE_ID = 122

const QCategory = () => {
  const [modal_Access, setAccessDenied] = useState(false)

  const checkPermission = async (index, callback) => {
    setLoading(true)
    const formData = new FormData()
    formData.append("user_id", localStorage.getItem("auth_id"))
    formData.append("module_id", ASSESSMENT_MODULE_ID)
    try {
      const res = await axios({
        method: "post",
        url: `${configure.apiUrl}/earth_permission`,
        data: formData,
        headers: { Accept: "application/json", "Content-Type": "multipart/form-data" },
      })
      if (res.data.data.india[index] == 1 || res.data.data.uk[index] == 1) {
        callback()
      } else {
        setAccessDenied(true)
      }
    } catch (e) {
      console.log(e)
    }
    setLoading(false)
  }

  const [permissions, setPermissions] = useState({ canAdd: false, canEdit: false, canDelete: false })

  const fetchPermissions = async () => {
    const formData = new FormData()
    formData.append("user_id", localStorage.getItem("auth_id"))
    formData.append("module_id", ASSESSMENT_MODULE_ID)
    try {
      const res = await axios({
        method: "post",
        url: `${configure.apiUrl}/earth_permission`,
        data: formData,
        headers: { Accept: "application/json", "Content-Type": "multipart/form-data" },
      })
      const india = res.data.data.india
      const uk = res.data.data.uk
      setPermissions({
        canAdd: india[3] == 1 || uk[3] == 1,
        canEdit: india[4] == 1 || uk[4] == 1,
        canDelete: india[5] == 1 || uk[5] == 1,
      })
    } catch (e) {
      console.log(e)
    }
  }

  const [data, setData] = useState([
    {
      id: 1,
      category: "Non-Technical",
    },
    {
      id: 2,
      category: "React Questions",
    },
    {
      id: 3,
      category: "JavaScript Questions",
    },
    {
      id: 4,
      category: "Node.js Questions",
    },
    {
      id: 5,
      category: "Data Structures & Algorithms",
    },
    {
      id: 6,
      category: "System Design",
    },
    {
      id: 7,
      category: "HR / Behavioral",
    },
    {
      id: 8,
      category: "Logical Reasoning",
    },
    {
      id: 9,
      category: "Aptitude",
    },
    {
      id: 10,
      category: "Seating Arrangement",
    },
    {
      id: 11,
      category: "Puzzles",
    },
  ])
  const [loading, setLoading] = useState(false)
  const [exportingId, setExportingId] = useState(null)
  const [modal, setModal] = useState(false)
  const [status, setStatus] = useState(false)

  // Edit states
  const [editId, setEditId] = useState(null)
  const [categoryName, setCategoryName] = useState("")

  // Fetch Data
  const getData = async () => {
    const userId = localStorage.getItem("auth_id")
    const response = await fetchNodeData(
      setLoading,
      `preassesment/category/getCategory/${userId}`,
      secureLocalStorage?.getItem("auth_token")
    )
    setData(response.data)
  }

  const handleAddCategory = async e => {
    e.preventDefault()
    let payload = {
      name: categoryName,
      user_id: localStorage.getItem("auth_id"),
    }

    const response = await FetchNodePostData(
      setLoading,
      "preassesment/category/add",
      secureLocalStorage?.getItem("auth_token"),
      payload
    )
    console.log("add response: ", response)

    if (
      response.data.success ||
      response.data.data.success ||
      response.success
    ) {
      Swal.fire("Success", "Category added successfully", "success")
      getData()
      setStatus(false)
      setCategoryName("")
    }
  }

  useEffect(() => {
    getData()
    fetchPermissions()
  }, [])

  const handleDeleteCategory = async id => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
      })

      if (!result.isConfirmed) return

      const response = await FetchNodeDeleteData(
        setLoading,
        "preassesment/category/deleteCategory",
        id
      )

      const success =
        response?.data?.success ||
        response?.data?.data?.success ||
        response?.success

      if (success) {
        await Swal.fire("Success", "Category deleted successfully", "success")
        getData()
      } else {
        Swal.fire("Error", "Failed to delete category", "error")
      }
    } catch (error) {
      console.error(error)
      Swal.fire("Error", "Something went wrong", "error")
    }
  } 

  const handleEditCategory = async e => {
    e.preventDefault()
    let payload = {
      name: categoryName,
    }
    const response = await FetchNodePutData(
      setLoading,
      `preassesment/category/editCategory`,
      editId,
      payload
    )
    console.log("edit response: ", response)

    if (
      response.data.success ||
      response.data.data.success ||
      response.success
    ) {
      Swal.fire("Success", "Category updated successfully", "success")
      getData()
      setEditId(null)
      setCategoryName("")
      setModal(false)
    }
  }

  const handleExportCategory = async (categoryId, categoryName) => {
    try {
      setExportingId(categoryId)
      const userId = localStorage.getItem("auth_id")
      const response = await fetchNodeData(
        null,
        `preassesment/questions/getQuestions/${userId}?category=${categoryId}&export=1`,
        secureLocalStorage?.getItem("auth_token")
      )
      const questions = response?.data
      if (!Array.isArray(questions) || questions.length === 0) {
        Swal.fire("Info", "No questions found for this category.", "info")
        return
      }

      const TYPE_LABEL = { 1: "MCQ", 2: "Code Editor", 3: "Text Input" }

      const rows = questions.map((q, i) => {
        let opts = {}
        try { opts = q.options ? JSON.parse(q.options) : {} } catch {}
        return {
          "Sr No":       i + 1,
          "Question":    q.question,
          "Type":        TYPE_LABEL[Number(q.type)] || q.type,
          "Option 1":    opts[1] ?? "",
          "Option 2":    opts[2] ?? "",
          "Option 3":    opts[3] ?? "",
          "Option 4":    opts[4] ?? "",
          "Correct Ans": q.correct_ans,
          "Duration":    q.duration,
        }
      })

      const ws = XLSX.utils.json_to_sheet(rows)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, "Questions")
      const safeName = (categoryName || "Category").replace(/[^a-z0-9_\- ]/gi, "").trim()
      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" })
      saveAs(new Blob([wbout], { type: "application/octet-stream" }), `${safeName}_Questions.xlsx`)
    } catch (e) {
      console.error(e)
      Swal.fire("Error", "Failed to export questions.", "error")
    } finally {
      setExportingId(null)
    }
  }

  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        className: "text-center",
      },
      {
        Header: "Category Name",
        accessor: "name",
        className: "col-5",
      },
      {
        Header: "Questions",
        accessor: "question_count",
        className: "text-center",
        Cell: ({ row }) => {
          const count = Number(row.original.question_count) || 0
          return (
            <span
              style={{
                display: "inline-block",
                minWidth: 32,
                padding: "2px 10px",
                borderRadius: 20,
                background: count > 0 ? "#f0e6f6" : "#f1f3f5",
                color: count > 0 ? "#752a97" : "#aaa",
                fontWeight: 600,
                fontSize: 13,
              }}
            >
              {count}
            </span>
          )
        },
      },
      {
        Header: "Last Uploaded",
        accessor: "last_uploaded",
        className: "text-center",
        Cell: ({ row }) => {
          const ts = row.original.last_uploaded
          if (!ts) return <span style={{ color: "#bbb", fontSize: 12 }}>—</span>
          const d = new Date(ts)
          const formatted = d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) +
            ", " + d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", hour12: true })
          return <span style={{ fontSize: 12, color: "#555" }}>{formatted}</span>
        },
      },
      {
        Header: "Action",
        accessor: "action",
        Cell: cellProps => {
          const row = cellProps.row.original
          const isExporting = exportingId === row.id
          return (
            <div className="d-flex gap-1">
              <button
                className="btn btn-sm btn-info"
                title={`Export questions for "${row.name}"`}
                disabled={isExporting}
                onClick={() => handleExportCategory(row.id, row.name)}
              >
                {isExporting
                  ? <i className="fas fa-spinner fa-spin"></i>
                  : <i className="fas fa-file-excel"></i>
                }
              </button>
              {permissions.canEdit && (
                <button
                  onClick={() =>
                    checkPermission(4, () => {
                      setEditId(row.id)
                      setCategoryName(row.name || "")
                      setModal(true)
                    })
                  }
                  className="btn btn-sm btn-outline-secondary"
                >
                  <i className="fas fa-pencil-alt"></i>
                </button>
              )}
              {permissions.canDelete && (
                <button
                  className="btn btn-sm btn-danger"
                  onClick={e => {
                    e.preventDefault()
                    checkPermission(5, () => handleDeleteCategory(row.id))
                  }}
                >
                  <i className="fas fa-trash-alt"></i>
                </button>
              )}
            </div>
          )
        },
      },
    ],
    [permissions, exportingId]
  )

  return (
    <div>
      {loading && <Loader />}
      <Row>
        <Col lg={12} className="p-0">
          <div className="responsive-table">
            <TableContainer
              columns={columns}
              data={data || []}
              getData={getData}
              setLoading={setLoading}
              handleAddCategory={handleAddCategory}
              categoryName={categoryName}
              setCategoryName={setCategoryName}
              setStatus={setStatus}
              status={status}
              canAdd={permissions.canAdd}
              onAddPermission={() => checkPermission(3, () => setStatus(true))}
            />
          </div>
        </Col>

        <CategoryModal
          status={modal}
          setStatus={setModal}
          setCategoryName={setCategoryName}
          categoryName={categoryName}
          categoryId={editId}
          handleAddCategory={handleAddCategory}
          handleEditCategory={handleEditCategory}
        />
      </Row>

      <AccessDeniedPopup
        modal_Access={modal_Access}
        setAccessDenied={setAccessDenied}
      />
    </div>
  )
}

export default QCategory
